import { Divider, Stack } from '@mui/joy';
import { Box } from '@mui/system';
import { useParams } from '@tanstack/react-router';
import { Fragment } from 'react/jsx-runtime';

import { ButtonLink } from '@/components/router/ButtonLink';
import { SignCodeIcon } from '@/components/signs/SignCodeIcon';
import { EditModalDialog } from '@/components/signs/modal/EditModalDialog';
import { I18N_DE } from '@/i18n/de';
import { useSignSupportQuery } from '@/queries/useSignSupportQuery';

type EditSwitchModalProps = { setOpen: (open: boolean) => void };

export function EditSwitchModal({ setOpen }: EditSwitchModalProps) {
  const { adminLevelId, signSupportId, signGroupId } = useParams({ strict: false });
  const { data: support } = useSignSupportQuery();

  if (!adminLevelId || !signSupportId) {
    return null;
  }

  return (
    <EditModalDialog onClose={() => setOpen(false)} title="Was möchten Sie bearbeiten?">
      <Stack gap={2}>
        {support?.groups
          ?.filter((group) => (signGroupId ? group.id === signGroupId : true))
          .map((group) => (
            <Fragment key={group.id}>
              {group.signs
                ?.filter((sign) => sign.status !== 'DELETED')
                .map((sign) => (
                  <ButtonLink
                    key={sign.id}
                    variant="outlined"
                    to="/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/$signId/bearbeiten"
                    params={{ adminLevelId, signSupportId, signGroupId: group.id, signId: sign.id }}
                    onClick={() => setOpen(false)}
                  >
                    <Stack direction="row" gap={1} alignItems="center" width="100%" justifyContent="space-between">
                      Verkehrszeichen {sign.code}
                      <SignCodeIcon code={sign.code} style={{ width: 30, height: 30, marginRight: 10 }} />
                    </Stack>
                  </ButtonLink>
                ))}
              <ButtonLink
                variant="outlined"
                to="/verkehrszeichen/$adminLevelId/$signSupportId/$signGroupId/bearbeiten"
                params={{ adminLevelId, signSupportId, signGroupId: group.id }}
                onClick={() => setOpen(false)}
              >
                <Stack direction="row" gap={1} alignItems="center" width="100%" justifyContent="space-between">
                  {`${I18N_DE.SignGroupType[group.type]} (Gruppe)`}
                  <Box>
                    {group.signs?.map((sign) => (
                      <SignCodeIcon
                        key={sign.id}
                        deleted={sign.status === 'DELETED'}
                        code={sign.code}
                        style={{ width: 30, height: 30, marginRight: 10 }}
                      />
                    ))}
                  </Box>
                </Stack>
              </ButtonLink>
              <Divider />
            </Fragment>
          ))}

        <ButtonLink
          variant="outlined"
          to="/verkehrszeichen/$adminLevelId/$signSupportId/bearbeiten"
          params={{ adminLevelId, signSupportId }}
          onClick={() => setOpen(false)}
        >
          <Stack direction="row" gap={1} alignItems="left" width="100%" justifyContent="space-between">
            Aufstellvorrichtung
          </Stack>
        </ButtonLink>
      </Stack>
    </EditModalDialog>
  );
}
